export const safeSendersCopy = {
  title: '',
  description: '',
  addLabel: '',
  addButton: '',
  searchPlaceholder: '',
  isNew: '',
  isDeleted: '',
  emailDomainHint: '',
  maxListCountMessage: '',
  maxListCountHint: '',
  emptySenderList: '',
};
